import { Subscription, fromEvent } from 'rxjs';

export interface ReplaceBrokenImage {
  (opts: { placeholder: string }, document: Document): Subscription;
}
export const replaceBrokenImage: ReplaceBrokenImage = (opts: { placeholder: string }, document: Document) => {
  Array.from(document.querySelectorAll('img')).forEach((element: HTMLImageElement): void => {
    if (element.complete) {
      if (element.naturalWidth === 0 || element.naturalHeight === 0) {
        setPlaceholder(element, opts.placeholder);
      }
    }
  });

  const imgs = document.querySelectorAll('img');
  if (!imgs.length) {
    return new Subscription();
  }
  return fromEvent(imgs, 'error').subscribe(($event: ErrorEvent) => {
    const element = $event.target as HTMLImageElement;
    if (element.hasAttribute('data-broken-src')) {
      return;
    }
    setPlaceholder(element, opts.placeholder);
  });
};

function setPlaceholder(element: HTMLImageElement, placeholder: string): void {
  element.setAttribute('data-broken-src', element.src);
  element.src = placeholder;
}
